import { ToastProvider } from '@iheartjane/reefer';
import type { Nullish } from '@iheartjane/types';
import type { PropsWithChildren } from 'react';

import { Toasts } from '@jane/bloom/components/toast/toasts';
import { StoreSwitcherProvider } from '@jane/bloom/hooks/storeSwitcher/useStoreSwitcher';
import { CustomLanguageContext } from '@jane/bloom/hooks/useCustomLanguage';
import { HasStoreBannerProvider } from '@jane/bloom/hooks/useHasStoreBanner';
import { SkeletonLoaderProvider } from '@jane/bloom/hooks/useSkeletonLoader';
import { UserSearchQueryProvider } from '@jane/bloom/hooks/useUserSearchQuery';
import { AuthModalProvider } from '@jane/bloom/providers/authModalProvider';
import type { CustomLanguage } from '@jane/bloom/types/schemas/bloom/customLanguage';

interface AppWrappersProps {
  customLanguage: CustomLanguage;
  googleSsoClientId?: Nullish<string>;
}

export const AppWrappers = ({
  children,
  customLanguage,
  googleSsoClientId,
}: PropsWithChildren<AppWrappersProps>) => (
  <CustomLanguageContext.Provider value={customLanguage}>
    <UserSearchQueryProvider>
      <StoreSwitcherProvider>
        <HasStoreBannerProvider>
          <SkeletonLoaderProvider>
            <ToastProvider verticalOffset={100} render={Toasts}>
              <AuthModalProvider googleSsoClientId={googleSsoClientId}>
                {children}
              </AuthModalProvider>
            </ToastProvider>
          </SkeletonLoaderProvider>
        </HasStoreBannerProvider>
      </StoreSwitcherProvider>
    </UserSearchQueryProvider>
  </CustomLanguageContext.Provider>
);
